import React, { lazy, Suspense } from 'react';

// Resolve the initial route before hydration so its fallback cannot replace
// already-rendered content. Other routes still load only when visited.
export const preloadableRoute = (load) => {
  let ready;
  const Deferred = lazy(load);
  const Route = (props) => {
    if (ready) return React.createElement(ready, props);
    return (
      <Suspense fallback={<div className="app-preloader-wrapper"><div className="app-preloader"><span /><span /></div></div>}>
        <Deferred {...props} />
      </Suspense>
    );
  };
  Route.preload = () => load().then((module) => { ready = module.default; });
  return Route;
};
